import type { FPlusFunctionScopeOutput } from '@festina/configuration-general-types/configuration'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { PropsWithChildren } from 'react'

import { useFPlusScopeFilterValue } from '../../context/fPlusScopeFilterValueContext'
import { MarkdownViewer } from '../markdownviewer/MarkdownViewer'
import { HoverMenuList } from './HoverMenuList'

type FPlusFunctionScopeListProps = PropsWithChildren & {
  functions: FPlusFunctionScopeOutput[]
}

export const FPlusFunctionScopeList = ({
  functions,
  children,
}: FPlusFunctionScopeListProps) => {
  const translate = useTranslate()
  const { filterValue } = useFPlusScopeFilterValue()

  return (
    <HoverMenuList
      filterValue={filterValue}
      elements={functions.sort((a, b) =>
        a.functionName!.localeCompare(b.functionName!),
      )}
      renderLabel={(func) => (
        <div className="flex w-full">
          <MarkdownViewer className="grow overflow-hidden truncate text-left text-base">
            {`\`${func.functionName}\``}
          </MarkdownViewer>

          <p className="w-[35%] overflow-hidden truncate text-right italic text-gray-300">
            <MarkdownViewer>{`\`${func.functionSignature}\``}</MarkdownViewer>
          </p>
        </div>
      )}
      renderHover={(func) => (
        <div
          className={cx(
            'h-full w-[40em] overflow-auto p-2 text-left',
            paperStyles({ isFaded: false }),
          )}
        >
          <MarkdownViewer className="text-right">{`\`${func.functionSignature}\``}</MarkdownViewer>

          <MarkdownViewer shouldTransformLinksToDocSite>
            {`### ${translate('templateViewer.sidebar.scopePopover.documentation')}\n${func.functionDocumentation ?? translate('templateViewer.sidebar.scopePopover.noDocumentation')}`}
          </MarkdownViewer>
        </div>
      )}
    >
      {children}
    </HoverMenuList>
  )
}
